import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "inventory-template-page" }
const _hoisted_2 = { class: "inventory-template-page__header" }
const _hoisted_3 = { class: "inventory-template-page__title" }
const _hoisted_4 = {
  key: 0,
  class: "inventory-template-page__edit-banner"
}
const _hoisted_5 = { class: "inventory-template-page__edit-banner-label" }
const _hoisted_6 = { class: "inventory-template-page__edit-banner-hint" }
const _hoisted_7 = { class: "inventory-template-page__edit-banner-actions" }
const _hoisted_8 = { class: "inventory-template-page__preview-header-row" }
const _hoisted_9 = { class: "inventory-template-page__preview-title" }
const _hoisted_10 = { class: "inventory-template-page__preview-description" }
const _hoisted_11 = { class: "inventory-template-page__preview-headers" }
const _hoisted_12 = ["onDragstart", "onDragover", "onDrop"]
const _hoisted_13 = {
  key: 0,
  class: "inventory-template-page__preview-tag inventory-template-page__preview-tag--more"
}
const _hoisted_14 = {
  key: 1,
  class: "inventory-template-page__preset-list"
}
const _hoisted_15 = { class: "inventory-template-page__preset-list-hint" }
const _hoisted_16 = { class: "inventory-template-page__preset-list-hint-title" }
const _hoisted_17 = { class: "inventory-template-page__preset-chips" }
const _hoisted_18 = { class: "inventory-template-page__preset-chip-content" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "inventory-template-page__preset-chip-actions" }
const _hoisted_21 = ["aria-label", "onClick"]
const _hoisted_22 = ["aria-label", "onClick"]
const _hoisted_23 = { class: "inventory-template-page__preview-actions" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { class: "inventory-template-page__back-button-wrapper" }
const _hoisted_26 = { class: "inventory-template-page__sections" }
const _hoisted_27 = { class: "inventory-template-page__section" }
const _hoisted_28 = { class: "inventory-template-page__section-title" }
const _hoisted_29 = { class: "inventory-template-page__section-description" }
const _hoisted_30 = { class: "inventory-template-page__checkbox-grid" }
const _hoisted_31 = ["checked", "onChange"]
const _hoisted_32 = { class: "inventory-template-page__section" }
const _hoisted_33 = { class: "inventory-template-page__section-title" }
const _hoisted_34 = {
  key: 0,
  class: "inventory-template-page__tooltip"
}
const _hoisted_35 = { class: "inventory-template-page__section-description" }
const _hoisted_36 = { class: "inventory-template-page__checkbox-grid" }
const _hoisted_37 = ["checked", "onChange"]
const _hoisted_38 = { class: "inventory-template-page__section" }
const _hoisted_39 = { class: "inventory-template-page__section-title" }
const _hoisted_40 = { class: "inventory-template-page__section-description" }
const _hoisted_41 = { class: "inventory-template-page__settings-content" }
const _hoisted_42 = { class: "inventory-template-page__period" }
const _hoisted_43 = { class: "inventory-template-page__period-label" }
const _hoisted_44 = { class: "inventory-template-page__period-inputs" }
const _hoisted_45 = { class: "inventory-template-page__period-item" }
const _hoisted_46 = { class: "inventory-template-page__period-item-label" }
const _hoisted_47 = { class: "inventory-template-page__calendar-wrapper" }
const _hoisted_48 = { class: "inventory-template-page__period-item" }
const _hoisted_49 = { class: "inventory-template-page__period-item-label" }
const _hoisted_50 = { class: "inventory-template-page__calendar-wrapper" }
const _hoisted_51 = { class: "inventory-template-page__format" }
const _hoisted_52 = { class: "inventory-template-page__format-label" }
const _hoisted_53 = { class: "inventory-template-page__format-options" }
const _hoisted_54 = ["checked"]
const _hoisted_55 = { class: "inventory-template-page__radio-content" }
const _hoisted_56 = { class: "inventory-template-page__radio-label" }
const _hoisted_57 = { class: "inventory-template-page__radio-example" }
const _hoisted_58 = ["checked"]
const _hoisted_59 = { class: "inventory-template-page__radio-content" }
const _hoisted_60 = { class: "inventory-template-page__radio-label" }
const _hoisted_61 = { class: "inventory-template-page__radio-example" }
const _hoisted_62 = { class: "inventory-template-page__save-modal" }
const _hoisted_63 = { class: "inventory-template-page__save-modal-label" }
const _hoisted_64 = ["placeholder"]

import MonthPicker from '@/corePagesModule/components/MonthPicker.vue';
import TextButton from '@/components/input/Btn/TextButton.vue';
import SvgLoader from '@/utils/SvgLoader.vue';
import InfoModal from '@/corePagesModule/components/InfoModal.vue';
import Mdi from '@/corePagesModule/components/Mdi.vue';
import { i18n } from '@/i18n';
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { IYearMonth } from '@/coreDomainsModule/date';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { useRouter } from 'vue-router';
import { showInfoModal } from '@/corePagesModule/components/InfoModal/InfoModalManager';
import { IInventoryTemplatePreset } from '../domains/entities/InventoryTemplate';

// Composables
import { useTemplateSelectableItems } from '../composables/useTemplateSelectableItems';
import { useTemplateDragDropReorder } from '../composables/useTemplateDragDropReorder';
import { useTemplatePreviewHeaders } from '../composables/useTemplatePreviewHeaders';
import { useInventoryTemplatePresets } from '../composables/useInventoryTemplatePresets';

// Types and Constants
import { OutputFormat, IMasterItem, IOutputDataItem, PreviewHeaderType } from '../domains/entities/InventoryTemplate';
import {
  getInitialMasterItems,
  getInitialOutputDataItems,
  MAX_PREVIEW_HEADERS,
  isSingleFieldOutputKey,
} from '../constants/inventoryTemplateConstants';

// Template functions
import {
  exportInventoryExcel,
  downloadExcelFromUrl,
  ExportInventoryExcelParams,
  getTemplateFilterState,
  clearTemplateFilterState,
} from './useInventoryStore/inventoryTemplate';
import { toast } from '@/corePagesModule/components/Toast/ToastManager';
import axios from 'axios';


export default /*@__PURE__*/_defineComponent({
  __name: 'InventoryTemplatePage',
  setup(__props) {

const t = i18n.t;
const router = useRouter();

/**
 * プレビューヘッダーのラベルを取得（i18n対応）
 * @param header - プレビューヘッダー
 * @returns 翻訳されたラベル
 */
const getHeaderLabel = (header: {
  type: string;
  masterKey?: string;
  outputDataKey?: string;
  yearMonth?: { year: number; month: number };
}): string => {
  if (header.type === 'master' && header.masterKey) {
    return t(header.masterKey);
  }
  if (header.type === 'outputData' && header.outputDataKey) {
    if (header.yearMonth) {
      return `${t('displayYearMonth', { year: header.yearMonth.year, month: header.yearMonth.month })}_${t(header.outputDataKey)}`;
    }
    return t(header.outputDataKey);
  }
  return '';
};

// Master Items - using composable
const {
  items: masterItems,
  selectedItems: selectedMasterItems,
  handleItemChange: handleMasterItemChange,
  reorderItems: reorderMasterItems,
  resetSelection: resetMasterItemSelection,
} = useTemplateSelectableItems<IMasterItem>(getInitialMasterItems());

// Output Data Items - using composable
const {
  items: outputDataItems,
  selectedItems: selectedOutputDataItems,
  handleItemChange: handleOutputDataItemChange,
  reorderItems: reorderOutputDataItems,
  moveSingleFieldItem: moveOutputDataSingleFieldItem,
  resetSelection: resetOutputDataItemSelection,
} = useTemplateSelectableItems<IOutputDataItem>(getInitialOutputDataItems());

// Output Settings
const currentYearMonth = DateService.convertDateToIYearMonth(new Date());
const startYearMonth = ref<IYearMonth>(currentYearMonth);
const endYearMonth = ref<IYearMonth>(DateService.getShiftedIYearMonthByMonths(currentYearMonth.year, currentYearMonth.month, 3));
const outputFormat = ref<OutputFormat>(OutputFormat.BY_MONTH);

const locale = computed(() => i18n.locale);

// Output Condition Presets（組織内で共有される保存済みの出力条件）
const { presets, fetchPresets, savePreset, updatePreset, deletePreset } = useInventoryTemplatePresets();

const showSaveModal = ref(false);
const saveModalName = ref('');
const activePresetId = ref<string | null>(null);
const editingPresetId = ref<string | null>(null);
const editingPresetName = computed(() => presets.value.find((preset) => preset.presetId === editingPresetId.value)?.name ?? '');

/**
 * 2つの年月の差（月単位）を計算する
 * @param target - 対象の年月
 * @param base - 基準となる年月
 * @returns targetがbaseから何ヶ月後か（負の値は前）
 */
const calculateMonthOffset = (target: IYearMonth, base: IYearMonth): number => {
  return (target.year - base.year) * 12 + (target.month - base.month);
};

/**
 * 現在画面に入っている出力条件から、保存・更新用のリクエストを組み立てる
 * 出力期間は「この操作を行った瞬間の今月」を基準にした相対オフセットとして計算する
 * @param name - 書式名
 */
const buildPresetUpsertRequest = (name: string) => {
  const now = DateService.convertDateToIYearMonth(new Date());
  return {
    name,
    masterItems: selectedMasterItems.value.map((item) => item.key),
    outputDataItems: selectedOutputDataItems.value.map((item) => item.key),
    singleFieldPositions: singleFieldPositions.value ?? null,
    startMonthOffset: calculateMonthOffset(startYearMonth.value, now),
    endMonthOffset: calculateMonthOffset(endYearMonth.value, now),
    outputFormat: outputFormat.value,
  };
};

/**
 * 出力書式の保存モーダルを開く
 */
const openSaveModal = () => {
  saveModalName.value = '';
  showSaveModal.value = true;
};

/**
 * 出力書式の保存モーダルを閉じる
 */
const closeSaveModal = () => {
  showSaveModal.value = false;
};

/**
 * 出力書式を新規保存する
 */
const handleSaveModalConfirm = async () => {
  if (!saveModalName.value.trim()) return;

  const result = await savePreset(buildPresetUpsertRequest(saveModalName.value.trim()));
  if (result.status.type === 'success') {
    activePresetId.value = result.status.data.presetId;
    showSaveModal.value = false;
  } else {
    toast.error(t('出力書式の保存に失敗しました'));
  }
};

/**
 * 指定したキーの配列だけを選択状態にする（配列の順序で選択順が振られる）
 * @param keys - 選択状態にするキーの配列
 * @param items - 対象の項目一覧
 * @param resetSelection - 選択状態をリセットする関数
 * @param handleItemChange - 選択状態を変更する関数
 */
const applySelectedKeys = <T extends { key: string }>(
  keys: string[],
  items: T[],
  resetSelection: () => void,
  handleItemChange: (item: T, checked: boolean) => void
) => {
  resetSelection();
  keys.forEach((key) => {
    const item = items.find((i) => i.key === key);
    if (item) {
      handleItemChange(item, true);
    }
  });
};

/**
 * 出力条件プリセットを画面に読み込む
 * @param preset - 読み込むプリセット
 */
const loadPreset = (preset: IInventoryTemplatePreset) => {
  applySelectedKeys(preset.masterItemKeys, masterItems.value, resetMasterItemSelection, handleMasterItemChange);
  applySelectedKeys(preset.outputDataItemKeys, outputDataItems.value, resetOutputDataItemSelection, handleOutputDataItemChange);

  // 開始月・終了月は「読み込んだ瞬間」の今月を基準に、保存されているオフセットから再計算する
  const now = DateService.convertDateToIYearMonth(new Date());
  startYearMonth.value = DateService.getShiftedIYearMonthByMonths(now.year, now.month, preset.startMonthOffset);
  endYearMonth.value = DateService.getShiftedIYearMonthByMonths(now.year, now.month, preset.endMonthOffset);

  outputFormat.value = preset.outputFormat;

  // 現在庫など単一フィールド項目の挿入位置を復元する
  // （ここまでの選択・期間・出力形式の変更により、previewHeadersは最新の状態になっている）
  const monthlyHeaders = previewHeaders.value.filter(
    (header) => header.type === PreviewHeaderType.OUTPUT_DATA && !isSingleFieldOutputKey(header.outputDataKey)
  );
  Object.entries(preset.singleFieldPositions ?? {}).forEach(([key, index]) => {
    const targetHeader = monthlyHeaders[index];
    if (targetHeader) {
      moveOutputDataSingleFieldItem(key, targetHeader.id);
    }
  });

  activePresetId.value = preset.presetId;
};

/**
 * プリセットのチップをクリックした際のハンドラー（読み込み）
 * @param preset - 対象のプリセット
 */
const handlePresetChipClick = (preset: IInventoryTemplatePreset) => {
  if (editingPresetId.value) return;
  loadPreset(preset);
};

/**
 * 鉛筆アイコンを押した際のハンドラー（編集モードに入る）
 * @param preset - 対象のプリセット
 */
const handlePresetEditClick = (preset: IInventoryTemplatePreset) => {
  loadPreset(preset);
  editingPresetId.value = preset.presetId;
};

/**
 * 編集モードをキャンセルする
 * 編集中に変更した内容を破棄し、プリセットの元の値に戻す
 */
const handleCancelEdit = () => {
  const preset = presets.value.find((p) => p.presetId === editingPresetId.value);
  if (preset) {
    loadPreset(preset);
  }
  editingPresetId.value = null;
};

/**
 * 編集内容を保存する
 */
const handleSaveEdit = async () => {
  if (!editingPresetId.value) return;

  const result = await updatePreset(editingPresetId.value, buildPresetUpsertRequest(editingPresetName.value));
  if (result.status.type === 'success') {
    activePresetId.value = result.status.data.presetId;
    editingPresetId.value = null;
  } else {
    toast.error(t('出力書式の更新に失敗しました'));
  }
};

/**
 * ゴミ箱アイコンを押した際のハンドラー（削除）
 * @param preset - 対象のプリセット
 */
const handlePresetDeleteClick = async (preset: IInventoryTemplatePreset) => {
  const confirmed = await showInfoModal({
    modalTitle: t('出力書式を削除'),
    modalDescription: t('出力書式「{name}」を削除します。よろしいですか？', { name: preset.name }),
    backButtonLabel: t('キャンセル'),
    nextButtonLabel: t('削除する'),
    icon: 'error',
    colorStyle: 'error',
  });
  if (!confirmed) return;

  const result = await deletePreset(preset.presetId);
  if (result.status.type === 'success') {
    if (activePresetId.value === preset.presetId) activePresetId.value = null;
    if (editingPresetId.value === preset.presetId) editingPresetId.value = null;
  } else {
    toast.error(t('出力書式の削除に失敗しました'));
  }
};

// Preview Headers - using composable
const { previewHeaders, showPreview, otherColumnsCount } = useTemplatePreviewHeaders(
  selectedMasterItems,
  selectedOutputDataItems,
  startYearMonth,
  endYearMonth,
  outputFormat
);

// Drag and Drop - using composable
const { draggedHeaderId, dragOverIndex, handleDragStart, handleDragEnd, handleDragOver, handleDrop } =
  useTemplateDragDropReorder(outputFormat);

/**
 * ドロップハンドラーのラッパー
 * @param event - ドラッグイベント
 * @param targetIndex - ターゲットインデックス
 */
const onDrop = (event: DragEvent, targetIndex: number) => {
  handleDrop(event, targetIndex, previewHeaders.value, reorderMasterItems, reorderOutputDataItems, moveOutputDataSingleFieldItem);
};

// Tooltip State for NX Explanation
const showTooltip = ref(false);
const tooltipRef = ref<HTMLElement | null>(null);

/**
 * ツールチップの表示切り替え
 */
const toggleTooltip = () => {
  showTooltip.value = !showTooltip.value;
};

/**
 * ツールチップを非表示にする（外部クリック検出用）
 * @param event - マウスイベント
 */
const handleClickOutside = (event: MouseEvent) => {
  if (tooltipRef.value && event.target && !tooltipRef.value.contains(event.target as Node)) {
    showTooltip.value = false;
  }
};

/**
 * ダウンロードボタンの有効性判定
 */
const isDownloadEnabled = computed(() => {
  const hasMasterItem = selectedMasterItems.value.length > 0;
  const hasOutputData = selectedOutputDataItems.value.length > 0;
  const hasPeriod = startYearMonth.value && endYearMonth.value;
  const hasFormat = outputFormat.value !== null;

  return hasMasterItem && hasOutputData && hasPeriod && hasFormat;
});

/**
 * 単一フィールド項目の挿入位置を計算
 * プレビューヘッダーから単一フィールド項目の位置を取得し、
 * 月別ヘッダー配列内でのインデックスとして返す
 */
const singleFieldPositions = computed<{ [key: string]: number } | undefined>(() => {
  // 出力データ項目のみを抽出（マスタ項目を除く）
  const outputHeaders = previewHeaders.value.filter((h) => h.type === PreviewHeaderType.OUTPUT_DATA);

  // 単一フィールド項目の位置を計算
  const positions: { [key: string]: number } = {};

  outputHeaders.forEach((header, idx) => {
    if (isSingleFieldOutputKey(header.outputDataKey)) {
      // この単一フィールド項目より前にある月別ヘッダーの数がインデックス
      const monthlyHeadersBefore = outputHeaders.slice(0, idx).filter((h) => !isSingleFieldOutputKey(h.outputDataKey)).length;
      positions[header.outputDataKey!] = monthlyHeadersBefore;
    }
  });

  return Object.keys(positions).length > 0 ? positions : undefined;
});

/**
 * 戻るボタンのハンドラー
 */
const handleBack = () => {
  router.back();
};

// Loading state
const isDownloading = ref(false);

/**
 * エラーの種類を判定してユーザーフレンドリーなメッセージを表示
 * @param error - エラーオブジェクト
 */
const handleExportError = (error: unknown) => {
  // Axiosタイムアウトエラーの判定
  if (axios.isAxiosError(error)) {
    if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
      toast.error(t('データ量が多いため処理がタイムアウトしました。出力期間を短くするか、項目数を減らしてください。'));
      return;
    }
    // ネットワークエラー（接続なし）
    if (error.code === 'ERR_NETWORK' || !error.response) {
      toast.error(t('ネットワークエラーが発生しました。接続を確認してください。'));
      return;
    }
    // サーバーエラー (5xx)
    if (error.response && error.response.status >= 500) {
      toast.error(t('サーバーエラーが発生しました。しばらく待ってから再度お試しください。'));
      return;
    }
  }
  // その他のエラー
  toast.error(t('Excelエクスポートに失敗しました'));
};

/**
 * Excelダウンロードボタンのハンドラー
 */
const handleDownload = async () => {
  if (!isDownloadEnabled.value || isDownloading.value) return;

  isDownloading.value = true;

  try {
    // Build params for inventoryTemplate
    const params: ExportInventoryExcelParams = {
      masterItems: selectedMasterItems.value.map((item) => item.key),
      outputDataItems: selectedOutputDataItems.value.map((item) => item.key),
      startYearMonth: startYearMonth.value,
      endYearMonth: endYearMonth.value,
      outputFormat: outputFormat.value,
      singleFieldPositions: singleFieldPositions.value,
      language: locale.value === 'en' ? 'en' : 'ja',
      filterItems: getTemplateFilterState().filterItems,
    };

    const result = await exportInventoryExcel(params);

    if (result.status.type === 'success') {
      const { download_url, file_name } = result.status.data;
      downloadExcelFromUrl(download_url, file_name);
    } else {
      // API returned error response
      const error = result.status.error;
      if (error.statusCode === 504 || error.statusCode === 408) {
        toast.error(t('データ量が多いため処理がタイムアウトしました。出力期間を短くするか、項目数を減らしてください。'));
      } else if (error.statusCode >= 500) {
        toast.error(t('サーバーエラーが発生しました。しばらく待ってから再度お試しください。'));
      } else {
        toast.error(t('Excelエクスポートに失敗しました'));
      }
      console.error('Export failed:', error);
    }
  } catch (error) {
    console.error('Export error:', error);
    handleExportError(error);
  } finally {
    isDownloading.value = false;
  }
};

onMounted(() => {
  document.addEventListener('click', handleClickOutside);
  fetchPresets();
});

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside);
  // フィルター情報をクリア
  clearTemplateFilterState();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(t)('データ出力')), 1)
    ]),
    (_unref(showPreview))
      ? (_openBlock(), _createElementBlock("section", {
          key: 0,
          class: _normalizeClass(["inventory-template-page__preview", { 'inventory-template-page__preview--editing': editingPresetId.value }])
        }, [
          (editingPresetId.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, [
                  _createVNode(SvgLoader, {
                    name: "editPen",
                    width: "16",
                    height: "16"
                  }),
                  _createTextVNode(" " + _toDisplayString(_unref(t)('編集中')) + ": " + _toDisplayString(editingPresetName.value), 1)
                ]),
                _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('下の設定を変更して「変更を保存」を押してください')), 1),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(TextButton, {
                    "button-style": 'btn-secondary',
                    size: 'btn-md',
                    "on-click": handleCancelEdit
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('キャンセル')), 1)
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(TextButton, {
                    "button-style": 'btn-primary',
                    size: 'btn-md',
                    "on-click": handleSaveEdit
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('変更を保存')), 1)
                    ], undefined, true),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("h2", _hoisted_9, _toDisplayString(_unref(t)('出力プレビュー')), 1),
            _createVNode(TextButton, {
              "button-style": 'btn-secondary',
              size: 'btn-md',
              disabled: !isDownloadEnabled.value || !!editingPresetId.value,
              "on-click": openSaveModal
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('出力書式を保存')), 1)
              ], undefined, true),
              _: 1
            }, 8, ["disabled"])
          ]),
          _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(t)('出力ヘッダーの並びを表示しています。')), 1),
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(previewHeaders).slice(0, _unref(MAX_PREVIEW_HEADERS)), (header, index) => {
              return (_openBlock(), _createElementBlock("span", {
                key: header.id,
                class: _normalizeClass(["inventory-template-page__preview-tag", {
            'inventory-template-page__preview-tag--dragging': _unref(draggedHeaderId) === header.id,
            'inventory-template-page__preview-tag--drag-over': _unref(dragOverIndex) === index,
          }]),
                draggable: true,
                onDragstart: ($event: any) => (_unref(handleDragStart)($event, header)),
                onDragend: _cache[0] || (_cache[0] = ($event: any) => (_unref(handleDragEnd)($event))),
                onDragover: _withModifiers(($event: any) => (_unref(handleDragOver)($event, index)), ["prevent"]),
                onDrop: ($event: any) => (onDrop($event, index))
              }, _toDisplayString(getHeaderLabel(header)), 43, _hoisted_12))
            }), 128)),
            (_unref(otherColumnsCount) > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, " ..." + _toDisplayString(_unref(t)('他{count}列', { count: _unref(otherColumnsCount) })), 1))
              : _createCommentVNode("", true)
          ]),
          (_unref(presets).length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("p", _hoisted_15, [
                  _createVNode(Mdi, {
                    icon: "save",
                    class: "inventory-template-page__preset-list-hint-icon"
                  }),
                  _createElementVNode("strong", _hoisted_16, _toDisplayString(_unref(t)('保存済み出力書式')), 1),
                  _createTextVNode(" — " + _toDisplayString(_unref(t)('クリックで読み込み、鉛筆アイコンで編集')), 1)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(presets), (preset) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: preset.presetId,
                      class: _normalizeClass(["inventory-template-page__preset-chip", {
              'inventory-template-page__preset-chip--active': activePresetId.value === preset.presetId && editingPresetId.value !== preset.presetId,
              'inventory-template-page__preset-chip--editing': editingPresetId.value === preset.presetId,
            }])
                    }, [
                      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "inventory-template-page__preset-chip-accent" }, null, -1)),
                      _createElementVNode("div", _hoisted_18, [
                        (activePresetId.value === preset.presetId && editingPresetId.value !== preset.presetId)
                          ? (_openBlock(), _createBlock(SvgLoader, {
                              key: 0,
                              name: "checkWhite",
                              width: "14",
                              height: "14",
                              class: "inventory-template-page__preset-chip-check"
                            }))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          class: "inventory-template-page__preset-chip-label",
                          type: "button",
                          onClick: ($event: any) => (handlePresetChipClick(preset))
                        }, [
                          (editingPresetId.value === preset.presetId)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_unref(t)('編集中')) + ": ", 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(preset.name), 1)
                        ], 8, _hoisted_19),
                        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "inventory-template-page__preset-chip-divider" }, null, -1)),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("button", {
                            class: "inventory-template-page__preset-chip-action inventory-template-page__preset-chip-action--edit",
                            type: "button",
                            "aria-label": _unref(t)('編集'),
                            onClick: ($event: any) => (handlePresetEditClick(preset))
                          }, [
                            _createVNode(Mdi, {
                              icon: "edit",
                              class: "inventory-template-page__preset-chip-action-icon"
                            })
                          ], 8, _hoisted_21),
                          _createElementVNode("button", {
                            class: "inventory-template-page__preset-chip-action inventory-template-page__preset-chip-action--delete",
                            type: "button",
                            "aria-label": _unref(t)('削除'),
                            onClick: ($event: any) => (handlePresetDeleteClick(preset))
                          }, [
                            _createVNode(SvgLoader, {
                              name: "trash-box",
                              width: "13",
                              height: "13"
                            })
                          ], 8, _hoisted_22)
                        ])
                      ])
                    ], 2))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("button", {
              class: _normalizeClass(["inventory-template-page__download-button", {
            'inventory-template-page__download-button--disabled': !isDownloadEnabled.value || isDownloading.value,
            'inventory-template-page__download-button--loading': isDownloading.value,
          }]),
              disabled: !isDownloadEnabled.value || isDownloading.value,
              onClick: handleDownload
            }, [
              _createTextVNode(_toDisplayString(isDownloading.value ? _unref(t)('ダウンロード中...') : _unref(t)('Excelをダウンロード')) + " ", 1),
              (!isDownloading.value)
                ? (_openBlock(), _createBlock(SvgLoader, {
                    key: 0,
                    name: "downloadSmall",
                    width: "16",
                    height: "16"
                  }))
                : _createCommentVNode("", true)
            ], 10, _hoisted_24),
            _createElementVNode("div", _hoisted_25, [
              _createVNode(TextButton, {
                "button-style": 'btn-secondary',
                size: 'btn-md',
                "on-click": handleBack
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('戻る')), 1)
                ], undefined, true),
                _: 1
              })
            ])
          ])
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("section", _hoisted_27, [
        _createElementVNode("h3", _hoisted_28, _toDisplayString(_unref(t)('マスタ項目')), 1),
        _createElementVNode("p", _hoisted_29, _toDisplayString(_unref(t)('出力する項目を選択してください')), 1),
        _createElementVNode("div", _hoisted_30, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(masterItems), (item) => {
            return (_openBlock(), _createElementBlock("label", {
              key: item.key,
              class: "inventory-template-page__checkbox-item"
            }, [
              _createElementVNode("input", {
                type: "checkbox",
                checked: item.checked,
                onChange: ($event: any) => (_unref(handleMasterItemChange)(item, ($event.target as HTMLInputElement).checked))
              }, null, 40, _hoisted_31),
              _createElementVNode("span", null, _toDisplayString(_unref(t)(item.key)), 1)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("section", _hoisted_32, [
        _createElementVNode("h3", _hoisted_33, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('出力データ')), 1),
          _createElementVNode("div", {
            ref_key: "tooltipRef",
            ref: tooltipRef,
            class: "inventory-template-page__tooltip-wrapper"
          }, [
            _createVNode(SvgLoader, {
              name: "questionIcon",
              class: "inventory-template-page__help-icon",
              onClick: toggleTooltip
            }),
            (showTooltip.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _createElementVNode("p", null, _toDisplayString(_unref(t)('客先内示(N-1)とは、受領月が前月の内示を表示します。')), 1),
                  _createElementVNode("p", null, _toDisplayString(_unref(t)('例: 2025年10月の内示を表示する場合、受領月は2025年9月の内示が表示されます。')), 1),
                  _createElementVNode("p", null, _toDisplayString(_unref(t)('仕入先内示(N-1)とは、作成月が前月の内示を表示します。')), 1),
                  _createElementVNode("p", null, _toDisplayString(_unref(t)('最新客先内示・最新仕入先内示は、対象月に登録されている内示のうち、受領月・作成月が最も新しいものを表示します。')), 1)
                ]))
              : _createCommentVNode("", true)
          ], 512)
        ]),
        _createElementVNode("p", _hoisted_35, _toDisplayString(_unref(t)('出力する数値データを選択してください')), 1),
        _createElementVNode("div", _hoisted_36, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(outputDataItems), (item) => {
            return (_openBlock(), _createElementBlock("label", {
              key: item.key,
              class: "inventory-template-page__checkbox-item"
            }, [
              _createElementVNode("input", {
                type: "checkbox",
                checked: item.checked,
                onChange: ($event: any) => (_unref(handleOutputDataItemChange)(item, ($event.target as HTMLInputElement).checked))
              }, null, 40, _hoisted_37),
              _createElementVNode("span", null, _toDisplayString(_unref(t)(item.key)), 1)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("section", _hoisted_38, [
        _createElementVNode("h3", _hoisted_39, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('出力設定')), 1),
          _createVNode(Mdi, {
            icon: "keyboard_arrow_right",
            class: "inventory-template-page__arrow-icon",
            "aria-hidden": "true"
          })
        ]),
        _createElementVNode("p", _hoisted_40, _toDisplayString(_unref(t)('出力期間と出力形式を選択してください')), 1),
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("label", _hoisted_43, _toDisplayString(_unref(t)('出力期間')), 1),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("label", _hoisted_46, _toDisplayString(_unref(t)('開始月')), 1),
                _createElementVNode("div", _hoisted_47, [
                  _createVNode(MonthPicker, {
                    class: "inventory-template-page__calendar inventory-template-page-period-calendar",
                    "model-value": startYearMonth.value,
                    locale: locale.value,
                    "prop-format": "yyyy / MM",
                    "max-date": endYearMonth.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (startYearMonth.value = $event))
                  }, null, 8, ["model-value", "locale", "max-date"]),
                  _createVNode(Mdi, {
                    icon: "calendar_today",
                    class: "inventory-template-page__calendar-icon"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("label", _hoisted_49, _toDisplayString(_unref(t)('終了月')), 1),
                _createElementVNode("div", _hoisted_50, [
                  _createVNode(MonthPicker, {
                    class: "inventory-template-page__calendar inventory-template-page-period-calendar",
                    "model-value": endYearMonth.value,
                    locale: locale.value,
                    "prop-format": "yyyy / MM",
                    "min-date": startYearMonth.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (endYearMonth.value = $event))
                  }, null, 8, ["model-value", "locale", "min-date"]),
                  _createVNode(Mdi, {
                    icon: "calendar_today",
                    class: "inventory-template-page__calendar-icon"
                  })
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("label", _hoisted_52, _toDisplayString(_unref(t)('出力形式')), 1),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("label", {
                class: _normalizeClass(["inventory-template-page__radio-item", { 'inventory-template-page__radio-item--selected': outputFormat.value === 'byMonth' }])
              }, [
                _createElementVNode("input", {
                  type: "radio",
                  name: "outputFormat",
                  value: "byMonth",
                  checked: outputFormat.value === 'byMonth',
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (outputFormat.value = 'byMonth'))
                }, null, 40, _hoisted_54),
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("span", _hoisted_56, _toDisplayString(_unref(t)('月単位で横並びにまとめる')), 1),
                  _createElementVNode("span", _hoisted_57, _toDisplayString(_unref(t)('例:1月(在庫、販売実績...)→2月(在庫、販売実績...)')), 1)
                ])
              ], 2),
              _createElementVNode("label", {
                class: _normalizeClass(["inventory-template-page__radio-item", { 'inventory-template-page__radio-item--selected': outputFormat.value === 'byDataType' }])
              }, [
                _createElementVNode("input", {
                  type: "radio",
                  name: "outputFormat",
                  value: "byDataType",
                  checked: outputFormat.value === 'byDataType',
                  onChange: _cache[4] || (_cache[4] = ($event: any) => (outputFormat.value = 'byDataType'))
                }, null, 40, _hoisted_58),
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("span", _hoisted_60, _toDisplayString(_unref(t)('データ種類単位で横並びにまとめる')), 1),
                  _createElementVNode("span", _hoisted_61, _toDisplayString(_unref(t)('例:在庫(1月、2月...)→販売実績(1月、2月...)')), 1)
                ])
              ], 2)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(InfoModal, {
      "modal-state": showSaveModal.value,
      "back-button-label": _unref(t)('キャンセル'),
      "next-button-label": _unref(t)('保存'),
      "is-disabled-next-button": !saveModalName.value.trim(),
      onOnBack: closeSaveModal,
      onOnNext: handleSaveModalConfirm
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('出力書式を保存')), 1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_62, [
          _createElementVNode("label", _hoisted_63, _toDisplayString(_unref(t)('書式名')), 1),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((saveModalName).value = $event)),
            type: "text",
            class: "inventory-template-page__save-modal-input",
            placeholder: _unref(t)('例: 標準月次レポート')
          }, null, 8, _hoisted_64), [
            [_vModelText, saveModalName.value]
          ])
        ])
      ], undefined, true),
      _: 1
    }, 8, ["modal-state", "back-button-label", "next-button-label", "is-disabled-next-button"])
  ]))
}
}

})